import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Navbar.css';

const links = [
  { label: 'Inicio',               to: 'inicio' },
  { label: 'Nosotros',             to: 'nosotros' },
  { label: 'Servicios',            to: 'servicios' },
  { label: 'Canales de Pago',      to: 'planes' },
  { label: 'Aliados Estratégicos', to: 'aliados' },
  { label: 'Contacto',             to: 'mapa' },
];

const Navbar = () => {
  const [open, setOpen]         = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { user, logout }        = useAuth();
  const navigate                = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setOpen(false);
  };

  return (
    <nav className={`navbar${scrolled ? ' navbar--scrolled' : ''}`}>
      <div className="navbar__inner">
        <button className="navbar__logo" onClick={() => scrollTo('inicio')}>
          <div className="navbar__logo-name">
            <span className="c">CASH</span><span className="s">SOL</span>
          </div>
          <div className="navbar__logo-sub">Préstamos con propósito</div>
        </button>

        <ul className="navbar__menu">
          {links.map((l) => (
            <li key={l.to}>
              <button onClick={() => scrollTo(l.to)}>{l.label}</button>
            </li>
          ))}
        </ul>

        <div className="navbar__auth">
          {user ? (
            <>
              <button className="navbar__auth-panel" onClick={() => navigate('/dashboard')}>
                <i className="fa-solid fa-user-circle"></i> {user.nombre}
              </button>
              <button className="navbar__auth-logout" onClick={() => { logout(); navigate('/'); }}>
                <i className="fa-solid fa-right-from-bracket"></i>
              </button>
            </>
          ) : (
            <>
              <button className="navbar__auth-login" onClick={() => navigate('/login')}>
                Mi Cuenta
              </button>
              <button className="btn-primary navbar__auth-register" onClick={() => navigate('/register')}>
                Solicitar
              </button>
            </>
          )}
        </div>

        <button
          className={`navbar__hamburger${open ? ' open' : ''}`}
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      <div className={`navbar__mobile${open ? ' navbar__mobile--open' : ''}`}>
        {links.map((l) => (
          <button key={l.to} onClick={() => scrollTo(l.to)}>
            {l.label}
          </button>
        ))}
        <hr className="navbar__mobile-divider" />
        {user ? (
          <>
            <button onClick={() => { navigate('/dashboard'); setOpen(false); }}>
              <i className="fa-solid fa-user-circle"></i> Mi panel
            </button>
            <button onClick={() => { logout(); navigate('/'); setOpen(false); }}>
              <i className="fa-solid fa-right-from-bracket"></i> Cerrar sesión
            </button>
          </>
        ) : (
          <>
            <button onClick={() => { navigate('/login'); setOpen(false); }}>Mi Cuenta</button>
            <button onClick={() => { navigate('/register'); setOpen(false); }}>Solicitar</button>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
